import { Loading } from '@/components/loading';
import { FarmCarbonInfoTable } from '@/components/tables/farm-carbon-table.component';
import { FieldSummaryTable } from '@/components/tables/field-summary-table.component';
import { cn } from '@/lib/utils';
import { useFieldSummaryData } from '@/modules/Report/Report.api';
import { FarmData } from '@/modules/Report/Report.schema';
import { toast } from 'react-toastify';

type Props = {
  farmData: FarmData;
  farmId: string;
};
export const FarmDetailList = ({ farmData, farmId }: Props) => {
  const { data, status } = useFieldSummaryData(farmId);

  if (status === 'error') {
    toast.error('Failed to fetch field summary');
    return;
  }

  return (
    <div className={cn('mt-4 mb-10 flex flex-col gap-6')}>
      <FarmCarbonInfoTable data={farmData} className={cn('shadow p-5')} />
      {status === 'pending' ? (
        <Loading />
      ) : (
        <FieldSummaryTable
          customerId={farmData.breadcrumb.client.id}
          projectId={farmData.breadcrumb.project.id}
          farmId={farmData.breadcrumb.farm.id}
          fieldSummaries={data}
        />
      )}
    </div>
  );
};
